import React from 'react';
import { Text } from 'react-native';
import GlobalStyles from './style';
import styles from './inGameStyles'

// Este objeto agrupa los mensajes por tipo de evento
export const eventMessages = {
	initialJumpBall: {
		es: [
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text>, del equipo <Text style={styles.matchTeam}>{xTeamName}</Text>, coge la Quaffle en el salto inicial.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> estira el brazo y se hace con la posesión inicial.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> vuela mas rápido que <Text style={styles.matchPlayer}>{yName}</Text> y llega primero a la Quaffle.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> from team <Text style={styles.matchTeam}>{xTeamName}</Text> grabs the Quaffle on the jump ball.
				</MessageWrapper>
			)
		],
		ca: [
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text>, de l'equip <Text style={styles.matchTeam}>{xTeamName}</Text>, agafa la Quaffle en el salt inicial.
				</MessageWrapper>
			)
		]
	},

	beforeShot: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> se hace hueco entre la defensa y dispara.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> se dispone a lanzar la Quaffle con todas sus fuerzas.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> makes himself room between the defenders and shots.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> throws the Quaffle with strength.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> es fa un lloc en la defensa i llença.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> es prepara per llençar la Quaffle.
				</MessageWrapper>
			),
		],
	},

	scoresThrow: {
		es: [
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						Y <Text style={styles.matchPlayer}>{xName}</Text> marca y consigue <Text style={styles.matchPoints}>10</Text> pts para <Text style={styles.matchTeam}>{xTeamName}</Text>.
					</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						<Text style={styles.matchPlayer}>{xName}</Text> marca el tanto.
					</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						Y <Text style={styles.matchPlayer}>{xName}</Text> ayuda a su equipo con <Text style={styles.matchPoints}>10</Text> pts.
					</Text>
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						¡Dentro! <Text style={styles.matchPoints}>10</Text> pts más para <Text style={styles.matchTeam}>{xTeamName}</Text>.
					</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						And <Text style={styles.matchPlayer}>{xName}</Text> scores and gets <Text style={styles.matchPoints}>10</Text> pts for <Text style={styles.matchTeam}>{xTeamName}</Text>.
					</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						<Text style={styles.matchPlayer}>{xName}</Text> scores a goal.
					</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						I <Text style={styles.matchPlayer}>{xName}</Text> marca i aconsegueix <Text style={styles.matchPoints}>10</Text> pts per <Text style={styles.matchTeam}>{xTeamName}</Text>.
					</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>
						<Text style={styles.matchPlayer}>{xName}</Text> marca un gol.
					</Text>
				</MessageWrapper>
			),
		],
	},

	afterScoreDribble: {
		es: [
			({ p }) => (
				<MessageWrapper p={p}>
					Menuda habilidad con la escoba, este jugador lo hace parecer facil.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> sabe como desmontar la defensa rival.
				</MessageWrapper>
			),
		],
		en: [
			({ p }) => (
				<MessageWrapper p={p}>
					What a broom! That is speed.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> knows hows how to dribble.
				</MessageWrapper>
			),
		],
		ca: [
			({ p }) => (
				<MessageWrapper p={p}>
					Quina velocitat, aquesta es una bona granera/escombra.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> sap com confundir a la defensa rival.
				</MessageWrapper>
			),
		],
	},

	afterScoreAssist: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Asistencia por parte de <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha dado la asistencia.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Assist by <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> has given the assist.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Asistencia per <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha donat l'asistencia.
				</MessageWrapper>
			),
		],
	},

	throwSaved: {
		es: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> detiene el disparo.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Quaffle parada por <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Buenos reflejos de <Text style={styles.matchPlayer}>{yName}</Text>, que detiene el disparo.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> muestra autoridad al detener ese balón.
				</MessageWrapper>
			),
		],
		en: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> stops the throw.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Quaffle stopped by <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> para el llançament.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Quaffle parada per <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
	},

	offensiveRebound: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> estira el brazo para ganar el rebote.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					El balon termina en manos de <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> streches his arm to win the rebound.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					The ball ends up in the hands of <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> estira el braç per guanyar el rebot.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					El baló acaba en mans de <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
		],
	},

	defensiveRebound: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> se hace con el rebote defensivo y se protege con los codos.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> cierra el rebote defensivo.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> gets the defensive rebound and protects himself with the shoulders.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> closes the defensive rebound.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> agafa el rebot defensiu i es protegeix amb els colzes.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> tanca el rebot defensiu.
				</MessageWrapper>
			),
		],
	},

	faultInThrow: {
		es: [
			({ p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Falta en el tiro.</Text>
				</MessageWrapper>
			),
			({ p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Una falta necesaria, ese tiro podria haber acabado dentro.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Fault in the throw.</Text>
				</MessageWrapper>
			),
			({ p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>A necessary fault, that could've ended up inside the rings.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Falta en el llançament.</Text>
				</MessageWrapper>
			),
			({ p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Una falta necesaria, això podria haber-hi acabat dins.</Text>
				</MessageWrapper>
			),
		],
	},

	stealBeforeThrow: {
		es: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					Buena accion defensiva por parte de <Text style={styles.matchPlayer}>{yName}</Text>, que logra robarle la Quaffle a <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Pase de <Text style={styles.matchPlayer}>{xName}</Text> interceptado por <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Good defensive action by <Text style={styles.matchPlayer}>{yName}</Text>, that steals the Quaffle from <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Pass of <Text style={styles.matchPlayer}>{xName}</Text> intercepted by <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Bona acció defensiva per <Text style={styles.matchPlayer}>{yName}</Text>, que aconsegueix robar la Quaffle de <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Pase de <Text style={styles.matchPlayer}>{xName}</Text> interceptat per <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
	},

	lostBallInArea: {
		es: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					Que mala suerte, <Text style={styles.matchPlayer}>{xName}</Text> pierde el balon ante una fuerte presión de <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Parece que <Text style={styles.matchPlayer}>{xName}</Text> tiene las manos untadas de mantequilla, menuda forma de perder el balon ante <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Bad luck, <Text style={styles.matchPlayer}>{xName}</Text> loses the ball to a strong pressure of <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Seems like <Text style={styles.matchPlayer}>{xName}</Text> has butter all over his hands, what a way to lose the ball to <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Mala sort, <Text style={styles.matchPlayer}>{xName}</Text> perd la pilota per una forta pressiò de <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					Sembla que <Text style={styles.matchPlayer}>{xName}</Text> te les mans untades de mantega, quina forma de perdre la pilota contra <Text style={styles.matchPlayer}>{yName}</Text>.
				</MessageWrapper>
			),
		],
	},

	gkTriesToSave: {
		es: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> intenta cubrir el aro mas cercano con los brazos.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> corre hacia los aros para poder recuperar ese balon.
				</MessageWrapper>
			),
		],
		en: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> tries to cover the closest ring with the arms.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> runs towards the rings to try and recover that ball.
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> intenta cobrir el cercol mes proper amb els braços.
				</MessageWrapper>
			),
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> corre als cercols per poder recuperar la pilota.
				</MessageWrapper>
			),
		],
	},

	dfTriesToSave: {
		es: [
			({ yName, xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					Perseguido de cerca por <Text style={styles.matchPlayer}>{yName}</Text>, <Text style={styles.matchPlayer}>{xName}</Text> intenta driblar al Guardián de <Text style={GlobalStyles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> sale del area con la intención de recortarle terreno a <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
		],
		en: [
			({ yName, xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					Followed closely by <Text style={styles.matchPlayer}>{yName}</Text>, <Text style={styles.matchPlayer}>{xName}</Text> tries to dribble the Guardian of <Text style={GlobalStyles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> gets out of the area to try and cut terrain to <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					Seguit d'aprop per <Text style={styles.matchPlayer}>{yName}</Text>, <Text style={styles.matchPlayer}>{xName}</Text> intenta driblar al Guardià de <Text style={GlobalStyles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> surt fora del area per intentar tallar-li terreny a <Text style={styles.matchPlayer}>{xName}</Text>.
				</MessageWrapper>
			),
		],
	},

	coolDribble: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>Que bonito regate y gol de <Text style={styles.matchPlayer}>{xName}</Text>, que consigue <Text style={styles.matchPoints}>10</Text> puntitos mas.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>Un atrevido juego de pies en su escoba logra hacer que <Text style={styles.matchPlayer}>{xName}</Text> marque un tanto.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>What a beautiful dribble of <Text style={styles.matchPlayer}>{xName}</Text>, that gets <Text style={styles.matchPoints}>10</Text> pts more.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>A bold feed move in its broom helps <Text style={styles.matchPlayer}>{xName}</Text> score a goal.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>Que bonic regat i gol de <Text style={styles.matchPlayer}>{xName}</Text>, que aconsegueix <Text style={styles.matchPoints}>10</Text> puntet mes.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>Un atrevit joc de peus en la seva granera fa que <Text style={styles.matchPlayer}>{xName}</Text> marqui un gol.</Text>
				</MessageWrapper>
			),
		],
	},

	lastMomentSave: {
		es: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> logra detener el contraataque y recuperar la posesión.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Menudo fallo de <Text style={styles.matchPlayer}>{xName}</Text>, era una ocasion clarisima, la Quaffle sale fuera.
				</MessageWrapper>
			),
		],
		en: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> stops the counter-attack.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					What a fail of <Text style={styles.matchPlayer}>{xName}</Text>, it was a clear-cut chance, the Quaffle gets out.
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> aconsegueix parar la contra.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Quina fallada de <Text style={styles.matchPlayer}>{xName}</Text>, era una ocasiò clarísima, la Quaffle surt fora.
				</MessageWrapper>
			),
		],
	},

	snitchCaptured: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchEnd}><Text style={styles.matchPlayer}>{xName}</Text> captura la snitch dorada y consigue <Text style={styles.matchPoints}>150</Text> puntos! El partido se termina</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchEnd}>La Snitch es atrapada por <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchEnd}><Text style={styles.matchPlayer}>{xName}</Text> captures the golden snitch and gets <Text style={styles.matchPoints}>150</Text> points! The game ends.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchEnd}>The Golden Snitch is captured by <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchEnd}><Text style={styles.matchPlayer}>{xName}</Text> captura la Snitch Daurada i aconsegueix <Text style={styles.matchPoints}>150</Text> punts! El partit s'acaba.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchEnd}>La Snitch Daurada es agafada per <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
	},

	gameEnds: {
		es: [
			() => (
				<Text style={styles.textCenter}>
					<Text style={styles.matchEnd}>El partido llega a su fin.</Text>
				</Text>
			),
			() => (
				<Text style={styles.textCenter}>
					<Text style={styles.matchEnd}>El arbitro indica el final del partido.</Text>
				</Text>
			),
		],
		en: [
			() => (
				<Text style={styles.textCenter}>
					<Text style={styles.matchEnd}>The game comes to an end.</Text>
				</Text>
			),
			() => (
				<Text style={styles.textCenter}>
					<Text style={styles.matchEnd}>The referee indicates the end of the game.</Text>
				</Text>
			),
		],
		ca: [
			() => (
				<Text style={styles.textCenter}>
					<Text style={styles.matchEnd}>El partit s'acaba.</Text>
				</Text>
			),
			() => (
				<Text style={styles.textCenter}>
					<Text style={styles.matchEnd}>L'arbitre indica el final del partit.</Text>
				</Text>
			),
		],
	},

	gonnaBeChanges: {
		es: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					El equipo <Text style={styles.matchTeam}>{xTeamName}</Text> va a realizar cambios.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					Se vienen cambios de rotación, el entrenador de <Text style={styles.matchTeam}>{xTeamName}</Text> manda calentar al banquillo.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					Se producirán cambios por parte de <Text style={styles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					El entrenador de <Text style={styles.matchTeam}>{xTeamName}</Text> va a realizar cambios de rotación.
				</MessageWrapper>
			),
		],
		en: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					The team <Text style={styles.matchTeam}>{xTeamName}</Text> is gonna do some changes.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					Rotational changes are on their way, <Text style={styles.matchTeam}>{xTeamName}</Text> sends the bench to warm up.
				</MessageWrapper>
			),
		],
		ca: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					El equip <Text style={styles.matchTeam}>{xTeamName}</Text> realitzarà canvis.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					Canvis de rotació, <Text style={styles.matchTeam}>{xTeamName}</Text> mana a calentar a la banqueta.
				</MessageWrapper>
			),
		],
	},

	gameStarts: {
		es: [
			() => (
				<Text style={styles.textCenter}>
					¡El partido empieza!
				</Text>
			),
			() => (
				<Text style={styles.textCenter}>
					¡El arbitro lanza la Quaffle, empieza el partido!
				</Text>
			),
		],
		en: [
			() => (
				<Text style={styles.textCenter}>
					The game starts!
				</Text>
			),
		],
		ca: [
			() => (
				<Text style={styles.textCenter}>
					El partit comença!
				</Text>
			),
		],
	},

	drawInfo: {
		es: [
			() => (
				<Text style={styles.textCenter}>
					¡Es un empate, parece que vamos a tener una tanda de Penaltis!
				</Text>
			),
		],
		en: [
			() => (
				<Text style={styles.textCenter}>
					It's a draw! Looks like we're gonna have a penalty shotout.
				</Text>
			),
		],
		ca: [
			() => (
				<Text style={styles.textCenter}>
					Es un empat! sembla que tindrem una tanda de penals.
				</Text>
			),
		],
	},

	weHaveAWinner: {
		es: [
			() => (
				<Text style={styles.textCenter}>
					¡Parece que tenemos un ganador!
				</Text>
			),
		],
		en: [
			() => (
				<Text style={styles.textCenter}>
					Looks like we have a winner!
				</Text>
			),
		],
		ca: [
			() => (
				<Text style={styles.textCenter}>
					Sembla que tenim un guanyador!
				</Text>
			),
		],
	},

	whoHasWon: {
		es: [
			({ xTeamName }) => (
				<Text style={[{ fontWeight: 'bold' }, styles.textCenter]}>
					Ha ganado <Text style={styles.matchTeam}>{xTeamName}</Text>
					{"\n\n\n"}
				</Text>
			),
		],
		en: [
			({ xTeamName }) => (
				<Text style={[{ fontWeight: 'bold' }, styles.textCenter]}>
					<Text style={styles.matchTeam}>{xTeamName}</Text> has won the game.
					{"\n\n\n"}
				</Text>
			),
		],
		ca: [
			({ xTeamName }) => (
				<Text style={[{ fontWeight: 'bold' }, styles.textCenter]}>
					Ha guanyat <Text style={styles.matchTeam}>{xTeamName}</Text>
					{"\n\n\n"}
				</Text>
			),
		],
	},

	beforeShotPenalty: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> se dispone a lanzar el proximo Penalti.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> está listo para disparar el Penalti.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> is preparing to take the Penalty.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> is ready to throw the Penalty.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> es disposa a disparar el Penal.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> està llest per llençar el Penal.
				</MessageWrapper>
			),
		],
	},
//todo
	penaltyScored: {
		es: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPlayer}>{xName}</Text> consigue meter la Quaffle entre los aros de <Text style={styles.matchPlayer}>{yName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPlayer}>{xName}</Text> engaña a <Text style={styles.matchPlayer}>{yName}</Text>, que se lanza al lado contrario.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPlayer}>{xName}</Text> manages to get the Quaffle through <Text style={styles.matchPlayer}>{yName}</Text>'s hoops.</Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPlayer}>{xName}</Text> tricks <Text style={styles.matchPlayer}>{yName}</Text>, who dives the wrong way.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPlayer}>{xName}</Text> aconsegueix colar la Quaffle entre els cèrcols de <Text style={styles.matchPlayer}>{yName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPlayer}>{xName}</Text> enganya a <Text style={styles.matchPlayer}>{yName}</Text>, que es llença cap al costat equivocat.</Text>
				</MessageWrapper>
			),
		],
	},

	penaltyFailed: {
		es: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Adivinando el tiro del lanzador, <Text style={styles.matchPlayer}>{yName}</Text> consigue parar la Quaffle.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> logra leer el tiro de <Text style={styles.matchPlayer}>{xName}</Text> y lo detiene con autoridad.
				</MessageWrapper>
			),
		],
		en: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Guessing the shooter's aim, <Text style={styles.matchPlayer}>{yName}</Text> manages to stop the Quaffle.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> reads <Text style={styles.matchPlayer}>{xName}</Text>'s shot perfectly and blocks it with authority.
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, p }) => (
				<MessageWrapper p={p}>
					Endevinant el llançament del tirador, <Text style={styles.matchPlayer}>{yName}</Text> aconsegueix aturar la Quaffle.
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{yName}</Text> llegeix el tir de <Text style={styles.matchPlayer}>{xName}</Text> i l'atura amb autoritat.
				</MessageWrapper>
			),
		],
	},

	bludgerHits: {
		es: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{yName}</Text> dispara la Bludger con acierto, que termina derribando a <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>Una potente Bludger deja conmocionad@ a <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{yName}</Text> lands a perfect Bludger hit, knocking <Text style={styles.matchPlayer}>{xName}</Text> down.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>A powerful Bludger strike leaves <Text style={styles.matchPlayer}>{xName}</Text> stunned.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{yName}</Text> encerta de ple amb la Bludger, que acaba fent caure <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>Una Bludger potent deixa a <Text style={styles.matchPlayer}>{xName}</Text> commocionat/da.</Text>
				</MessageWrapper>
			),
		],
	},

	bludgerSaves: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{xName}</Text> despeja una peligrosa Bludger. Buena defensa.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>Esa Bludger iba bien fuerte, suerte del rechazo de <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{xName}</Text> takes out that dangerous bludger. Good defense</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>That bludger came so fast, what a lucky denial of <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{xName}</Text> treu una perillosa Bludger. Bona defensa.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>Aquella Bludger anava ben fort, sort dels reflexes d'en <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
	},

	bludgerInjures: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}>Por culpa del lanzamiento de la Bludger, <Text style={styles.matchPlayer}>{xName}</Text> se ha acabado lesionando.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}>Esa Bludger le ha golpeado a <Text style={styles.matchPlayer}>{xName}</Text> fuerte en la muñeca, parece que tiene una fractura.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{xName}</Text> deflects a dangerous Bludger. Great defense.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>That Bludger was coming in hard — lucky block by <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}><Text style={styles.matchPlayer}>{xName}</Text> rebutja una Bludger perillosa. Bona defensa.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchBludger}>Aquella Bludger anava ben forta — sort del rebuig de <Text style={styles.matchPlayer}>{xName}</Text>.</Text>
				</MessageWrapper>
			),
		],
	},

	commitsFault: {
		es: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}><Text style={styles.matchPlayer}>{yName}</Text> comete falta sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Pitan falta a <Text style={styles.matchPlayer}>{yName}</Text> sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
		],
		en: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}><Text style={styles.matchPlayer}>{yName}</Text> comete falta sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Pitan falta a <Text style={styles.matchPlayer}>{yName}</Text> sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}><Text style={styles.matchPlayer}>{yName}</Text> comete falta sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Pitan falta a <Text style={styles.matchPlayer}>{yName}</Text> sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
		],
	},

	commitsFaultInAttack: {
		es: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}><Text style={styles.matchPlayer}>{yName}</Text> comete falta en ataque sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Pitan falta en ataque a <Text style={styles.matchPlayer}>{yName}</Text> sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
		],
		en: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}><Text style={styles.matchPlayer}>{yName}</Text> commits a foul on <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Foul called on <Text style={styles.matchPlayer}>{yName}</Text> against <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ yName, xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}><Text style={styles.matchPlayer}>{yName}</Text> comet una falta sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchFalta}>Falta xiulada a <Text style={styles.matchPlayer}>{yName}</Text> sobre <Text style={styles.matchPlayer}>{xName}</Text></Text>
				</MessageWrapper>
			),
		],
	},

	expulsion7Faults: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha cometido un total de 7 faltas, asi que el arbitro se dispone a expulsarlo del partido.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					¡Y ya van 7! <Text style={styles.matchPlayer}>{xName}</Text> es expulsado del partido por llegar al número de faltas permitidas.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> has committed a total of 7 fouls, so the referee is about to send them off.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					That makes 7! <Text style={styles.matchPlayer}>{xName}</Text> is sent off for reaching the foul limit.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha comès un total de 7 faltes, així que l'àrbitre es disposa a expulsar-lo del partit.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					¡Ja en van 7! <Text style={styles.matchPlayer}>{xName}</Text> és expulsat del partit per arribar al límit de faltes permeses.
				</MessageWrapper>
			),
		],
	},

	isInjuredByFault: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}>¡<Text style={styles.matchPlayer}>{xName}</Text> se acaba de lesionar! No podrá seguir jugando este partido.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}>¡<Text style={styles.matchPlayer}>{xName}</Text> se ha roto algo! Se perderá lo que queda de partido.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}><Text style={styles.matchPlayer}>{xName}</Text> just got injured! They won’t be able to continue this match.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}><Text style={styles.matchPlayer}>{xName}</Text> seems to have broken something! They’re out for the rest of the match.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}><Text style={styles.matchPlayer}>{xName}</Text> acaba de lesionar-se! No podrà continuar aquest partit.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchLesion}><Text style={styles.matchPlayer}>{xName}</Text> sembla que s’ha trencat alguna cosa! Es perdrà la resta del partit.</Text>
				</MessageWrapper>
			),
		],
	},

	isFlagrantFault: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Ha sido una entrada innecesaria, el arbitro le pita antideportiva a <Text style={styles.matchTeam}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					El banquillo de <Text style={styles.matchTeam}>{xTeamName}</Text> salta indignado ante tal entrada. ¡Pitan antideportiva!
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					It was an unnecessary move — the referee calls a flagrant foul on <Text style={styles.matchTeam}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					The <Text style={styles.matchTeam}>{xTeamName}</Text> bench erupts in outrage after the foul. Flagrant is called!
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Ha estat una entrada innecessària — l’àrbitre xiula falta antiesportiva a <Text style={styles.matchTeam}>{xName}</Text>.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					La banqueta de <Text style={styles.matchTeam}>{xTeamName}</Text> salta indignada per la jugada. Xiulen antiesportiva!
				</MessageWrapper>
			),
		],
	},

	plus30ptsOfFlagrant: {
		es: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>Se suman <Text style={styles.matchPoints}>30</Text> puntos a <Text style={styles.matchTeam}>{xTeamName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>Se suman <Text style={styles.matchPoints}>30</Text> puntos a <Text style={styles.matchTeam}>{xTeamName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPoints}>30</Text> points are added to <Text style={styles.matchTeam}>{xTeamName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}><Text style={styles.matchPoints}>30</Text> points are awarded to <Text style={styles.matchTeam}>{xTeamName}</Text>.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>S’afegeixen <Text style={styles.matchPoints}>30</Text> punts a <Text style={styles.matchTeam}>{xTeamName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPointsPhrase}>A <Text style={styles.matchTeam}>{xTeamName}</Text> se li sumen <Text style={styles.matchPoints}>30</Text> punts.</Text>
				</MessageWrapper>
			),
		],
	},

	beforePenaltyInfo: {
		es: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					Esta accion les va a costar un Penalti en contra a <Text style={styles.matchTeam}>{xTeamName}</Text>
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					El arbitro pita Penalti para <Text style={styles.matchTeam}>{xTeamName}</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					This action is going to cost <Text style={styles.matchTeam}>{xTeamName}</Text> a penalty against them.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					The referee awards a penalty to <Text style={styles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
		],
		ca: [
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					Aquesta acció els costarà un penal en contra a <Text style={styles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
			({ xTeamName, p }) => (
				<MessageWrapper p={p}>
					L’àrbitre xiula penal a favor de <Text style={styles.matchTeam}>{xTeamName}</Text>.
				</MessageWrapper>
			),
		],
	},

	ExpulsionDirectRedCard: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Eso es una falta muy fea... <Text style={styles.matchPlayer}>{xName}</Text> será expulsad@ del terreno de juego.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					¡Se l@ lleva por delante! <Text style={styles.matchPlayer}>{xName}</Text> se ha pasado de rosca. El arbitro no se lo piensa y le expulsa.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					That was a nasty foul... <Text style={styles.matchPlayer}>{xName}</Text> is being sent off with a red card.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					He completely takes them out! <Text style={styles.matchPlayer}>{xName}</Text> went way over the line. The referee doesn’t hesitate to send them off.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					Això ha estat una falta molt lletja... <Text style={styles.matchPlayer}>{xName}</Text> serà expulsat/da del terreny de joc.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					S’ho emporta per davant! <Text style={styles.matchPlayer}>{xName}</Text> s’ha passat de frenada. L’àrbitre no dubta i l’expulsa.
				</MessageWrapper>
			),
		],
	},

	exitEntersChange: {
		es: [
			({ xName, xNameSup, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>Sale <Text style={styles.matchPlayer}>{xName}</Text>, entra <Text style={styles.matchPlayer}>{xNameSup}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, xNameSup, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>Sale <Text style={styles.matchPlayer}>{xName}</Text>, entra <Text style={styles.matchPlayer}>{xNameSup}</Text>.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, xNameSup, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> goes off, <Text style={styles.matchPlayer}>{xNameSup}</Text> comes on.</Text>
				</MessageWrapper>
			),
			({ xName, xNameSup, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>Substitution: <Text style={styles.matchPlayer}>{xName}</Text> out, <Text style={styles.matchPlayer}>{xNameSup}</Text> in.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, xNameSup, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>Canvi: surt <Text style={styles.matchPlayer}>{xName}</Text>, entra <Text style={styles.matchPlayer}>{xNameSup}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, xNameSup, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> deixa el camp, <Text style={styles.matchPlayer}>{xNameSup}</Text> entra en joc.</Text>
				</MessageWrapper>
			),
		],
	},

	normalChange: {
		es: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> sale del terreno de juego y da entrada a su compañer@ <Text style={styles.matchPlayer}>{yName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> se despide de la afición mientras <Text style={styles.matchPlayer}>{yName}</Text> se monta en su escoba.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> leaves the pitch and is replaced by teammate <Text style={styles.matchPlayer}>{yName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> waves to the fans as <Text style={styles.matchPlayer}>{yName}</Text> hops on their broom.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> abandona el terreny de joc i dona entrada al seu company/a <Text style={styles.matchPlayer}>{yName}</Text>.</Text>
				</MessageWrapper>
			),
			({ xName, yName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> s'acomiada de l'afició mentre <Text style={styles.matchPlayer}>{yName}</Text> puja a la seva escombra.</Text>
				</MessageWrapper>
			),
		],
	},

	noChangeStaysInField: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>Al no estar disponible un jugador de su posición en el banquillo, <Text style={styles.matchPlayer}>{xName}</Text> tendrá que seguir jugando.</Text>
				</MessageWrapper>
			),
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> seguirá en el terreno de juego, puesto que {xTeamName} no dispone de mas cambios en su posición.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>With no available substitutes for their position, <Text style={styles.matchPlayer}>{xName}</Text> will have to stay on the field.</Text>
				</MessageWrapper>
			),
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> stays on the pitch, as {xTeamName} has no more changes available for that position.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>Com que no hi ha cap jugador disponible a la seva posició a la banqueta, <Text style={styles.matchPlayer}>{xName}</Text> haurà de continuar jugant.</Text>
				</MessageWrapper>
			),
			({ xName, xTeamName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> continuarà al camp, ja que {xTeamName} no té més canvis disponibles per a aquesta posició.</Text>
				</MessageWrapper>
			),
		],
	},

	entersFanRandom: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> no tiene cambio en el banquillo, asi que el entrenador escoge a un <Text style={styles.matchPlayer}>FAN RANDOM</Text> para jugar el partido.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>No quedan cambios para <Text style={styles.matchPlayer}>{xName}</Text>. Un <Text style={styles.matchPlayer}>FAN RANDOM</Text> se monta en una escoba de repuesto para sustituirlo.</Text>
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> has no substitutes left, so the coach picks a <Text style={styles.matchPlayer}>RANDOM FAN</Text> to enter the game.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>No subs left for <Text style={styles.matchPlayer}>{xName}</Text>. A <Text style={styles.matchPlayer}>RANDOM FAN</Text> hops on a spare broom to join the match.</Text>
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}><Text style={styles.matchPlayer}>{xName}</Text> no té recanvis a la banqueta, així que l’entrenador tria un <Text style={styles.matchPlayer}>FAN RANDOM</Text> per jugar el partit.</Text>
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.textSubstitute}>No queden canvis per a <Text style={styles.matchPlayer}>{xName}</Text>. Un <Text style={styles.matchPlayer}>FAN RANDOM</Text> puja a una escombra de recanvi per substituir-lo.</Text>
				</MessageWrapper>
			),
		],
	},

	template: {
		es: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha cometido un total de 7 faltas, asi que el arbitro se dispone a expulsarlo del partido.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					¡Y ya van 7! <Text style={styles.matchPlayer}>{xName}</Text> es expulsado del partido por llegar al número de faltas permitidas.
				</MessageWrapper>
			),
		],
		en: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha cometido un total de 7 faltas, asi que el arbitro se dispone a expulsarlo del partido.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					¡Y ya van 7! <Text style={styles.matchPlayer}>{xName}</Text> es expulsado del partido por llegar al número de faltas permitidas.
				</MessageWrapper>
			),
		],
		ca: [
			({ xName, p }) => (
				<MessageWrapper p={p}>
					<Text style={styles.matchPlayer}>{xName}</Text> ha cometido un total de 7 faltas, asi que el arbitro se dispone a expulsarlo del partido.
				</MessageWrapper>
			),
			({ xName, p }) => (
				<MessageWrapper p={p}>
					¡Y ya van 7! <Text style={styles.matchPlayer}>{xName}</Text> es expulsado del partido por llegar al número de faltas permitidas.
				</MessageWrapper>
			),
		],
	},

};

const MessageWrapper = ({ p, children }) => (
	<Text style={{
			maxWidth: '50%',
			alignSelf: p ? 'flex-end' : 'flex-start',
			textAlign: p ? 'right' : 'left',
		}}>
		{children}
	</Text>
  );
